import styled, { css } from 'styled-components'
import Link from 'next/link'

import { t } from 'localization'
import Image from 'shared/components/Image'
import { colors, media } from 'shared/lib'
import { Article } from 'shared/types'

const TP = 'editorial.components.NextArticle'

type NextArticleProps = {
  article: Article
}

export const NextArticle = ({ article }: NextArticleProps) => {
  return (
    <Container $backgroundColor={article?.draftBgColor}>
      <LinkContainer data-qa="NextArticleLink" href={`/article/${article?.slug}`}>
        <NextUp data-qa="NextArticleNextUp">{t(`${TP}.nextUp`, 'Next Up')}</NextUp>
        <Title data-qa="NextArticleTitle">{article?.subject}</Title>
        <ImageContainer style={{ aspectRatio: article?.coverPicture?.aspect }}>
          <Image
            alt={article?.description || ''}
            data-qa="NextArticleImage"
            src={article?.coverPicture?.largeUrl || ''}
            height={1200}
            width={1200}
            fill
          />
        </ImageContainer>
      </LinkContainer>
    </Container>
  )
}

const Container = styled.div<{ $backgroundColor?: string }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 80px;
  padding-top: 80px;
  width: 100vw;

  ${media.medium`
    padding-bottom: 240px;
    padding-top: 240px;
  `};

  ${({ $backgroundColor }) => {
    switch ($backgroundColor) {
      case 'black':
        return css`
          background-color: ${colors.FC2_BLACK};

          a {
            color: ${colors.FC2_WHITE};
          }
        `
      case 'red':
        return css`
          background-color: ${colors.FC2_RED};

          a {
            color: ${colors.FC2_BLACK};
          }
        `
      default:
        return css`
          background-color: ${colors.FC2_WHITE};

          a {
            color: ${colors.FC2_BLACK};
          }
        `
    }
  }}

  a {
    text-decoration: none;
  }
`
const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  min-width: 223px;
  width: auto;

  ${media.medium`
    max-height:100vh;
    width: auto;
  `};

  @media (width <= 767px) {
    max-width: calc(100% - 170px);
  }
`
const LinkContainer = styled(Link)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 100%;
  max-width: 100%;
`
const NextUp = styled.div`
  font-family: 'Helvetica Neue'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  margin-bottom: 8px;
  text-align: center;
  text-transform: uppercase;
`
const Title = styled.div`
  font-family: 'Ivar Headline'; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
  font-size: 32px;
  font-weight: 400;
  letter-spacing: -0.96px;
  line-height: 100%;
  margin-bottom: 40px;
  text-align: center;
  text-transform: uppercase;
  text-wrap: balance;

  ${media.medium`
    max-width: 440px;
  `};
`
